/**
 * PermissionActionButtons Component
 * Displays action buttons for permission requests
 */

import React from 'react'
import { Box } from '@mui/material'
import { Button as DesignSystemButton } from '../../../../interaxDesignSystemComponents'
import { useTranslation } from '../../../../shared/hooks/useIntractionTranslate'
import { PermissionState } from '../../helpers/permissionHelpers'

interface PermissionActionButtonsProps {
  permissionState: PermissionState
  hasError: boolean
  isRequestingPermissions: boolean
  onRequestPermissions: () => void
  onCheckAgain: () => void
}

export const PermissionActionButtons: React.FC<PermissionActionButtonsProps> = ({
  permissionState,
  hasError,
  isRequestingPermissions,
  onRequestPermissions,
  onCheckAgain
}) => {
  const { t } = useTranslation()
  const isDenied = permissionState === 'denied'

  const getButtonText = () => {
    if (isRequestingPermissions) {
      return t('gamer.permissionScreen.buttons.requesting')
    }
    if (isDenied) {
      return t('gamer.permissionScreen.buttons.tryAgain')
    }
    if (hasError) {
      return t('gamer.permissionScreen.buttons.retry')
    }
    return t('gamer.permissionScreen.buttons.allow')
  }

  return (
    <Box sx={{ mt: 2, display: 'flex', flexDirection: 'column', gap: 2, width: '100%', maxWidth: '300px' }}>
      <DesignSystemButton variant="primary" onClick={onRequestPermissions} disabled={isRequestingPermissions}>
        {getButtonText()}
      </DesignSystemButton>
      {(isDenied || hasError) && (
        <DesignSystemButton variant="secondary" onClick={onCheckAgain} disabled={isRequestingPermissions}>
          {t('gamer.permissionScreen.buttons.checkAgain')}
        </DesignSystemButton>
      )}
    </Box>
  )
}
